import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMediaObjectTextRight20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMediaObjectTextRight20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.5 3.5h2a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-11a1 1 0 0 1 1-1M1 4.5A2.5 2.5 0 0 1 3.5 2h2A2.5 2.5 0 0 1 8 4.5v11A2.5 2.5 0 0 1 5.5 18h-2A2.5 2.5 0 0 1 1 15.5zm10.049-.75a.75.75 0 0 1 .75-.75h6.396a.75.75 0 1 1 0 1.5h-6.396a.75.75 0 0 1-.75-.75m0 6a.75.75 0 0 1 .75-.75h6.396a.75.75 0 1 1 0 1.5h-6.396a.75.75 0 0 1-.75-.75m.75-3.75a.75.75 0 0 0 0 1.5h4.276a.75.75 0 0 0 0-1.5zm-.75 6.75a.75.75 0 0 1 .75-.75h4.276a.75.75 0 0 1 0 1.5h-4.276a.75.75 0 0 1-.75-.75"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMediaObjectTextRight20);
